import { memo, type ReactNode } from 'react';

import { Tooltip, type TooltipProps } from '@air/primitive-tooltip';

export type SkillTooltipSurfaceProps = Pick<TooltipProps, 'delayDuration' | 'open' | 'side' | 'sideOffset'> & {
  children: ReactNode;
  label: ReactNode;
};

export const SkillTooltipSurface = memo(
  ({ children, delayDuration = 200, label, open, side = 'top', sideOffset = 8 }: SkillTooltipSurfaceProps) => (
    <Tooltip
      className="max-w-[280px] rounded-8 bg-surface-1 p-4 font-normal text-12 text-gray-12 shadow-popover dark:border dark:border-gray-5"
      delayDuration={delayDuration}
      hideArrow
      label={label}
      open={open}
      side={side}
      sideOffset={sideOffset}
    >
      {children}
    </Tooltip>
  ),
);

SkillTooltipSurface.displayName = 'SkillTooltipSurface';
